import {
  FETCH_WFH_PROFILE_FAILURE,
  FETCH_WFH_PROFILE_LOADING,
  FETCH_WFH_PROFILE_SUCCESS,
  ADD_WFH_PROFILE_FAILURE,
  ADD_WFH_PROFILE_SUCCESS,
  ADD_WFH_PROFILE_LOADING,
  UPDATE_WFH_PROFILE_FAILURE,
  UPDATE_WFH_PROFILE_LOADING,
  UPDATE_WFH_PROFILE_SUCCESS,
  DELETE_WFH_PROFILE_FAILURE,
  DELETE_WFH_PROFILE_LOADING,
  DELETE_WFH_PROFILE_SUCCESS,
  FETCH_PLANNING_LOADING,
  FETCH_PLANNING_SUCCESS,
  FETCH_PLANNING_FAILURE,
  UPDATE_PLANNING_FAILURE,
  UPDATE_PLANNING_SUCCESS
} from '../Types/wfhProfileTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getWfhProfiles = () => {
  return dispatch => {
    dispatch({
      type: FETCH_WFH_PROFILE_LOADING
    });
    api
      .get(`${API_WP}WfhProfile`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_WFH_PROFILE_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_WFH_PROFILE_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getWfhProfileById = id => {
  return dispatch => {
    dispatch({
      type: FETCH_WFH_PROFILE_LOADING
    });
    api
      .get(`${API_WP}WfhProfile/search/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_WFH_PROFILE_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_WFH_PROFILE_FAILURE,
          payload: errorMsg
        });
      });
  };
};
export const addWfhProfile = data => {
  return dispatch => {
    dispatch({ type: ADD_WFH_PROFILE_LOADING });
    api
      .post(`${API_WP}WfhProfile/add`, data)
      .then(response => {
        dispatch({
          type: ADD_WFH_PROFILE_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: ADD_WFH_PROFILE_FAILURE,
          payload: error.message
        });
      });
  };
};
export const updateWfhProfile = (id, profile) => {
  return dispatch => {
    dispatch({ type: UPDATE_WFH_PROFILE_LOADING });
    api
      .put(`${API_WP}WFHprofile/update/${id}`, profile)
      .then(response => {
        dispatch({
          type: UPDATE_WFH_PROFILE_SUCCESS,
          payload: response.data
        });

        dispatch(getWfhProfiles());
      })
      .catch(error => {
        dispatch({
          type: UPDATE_WFH_PROFILE_FAILURE,
          payload: error.message
        });
      });
  };
};
export const removeWfhProfile = id => {
  return dispatch => {
    dispatch({ type: DELETE_WFH_PROFILE_LOADING });
    return api
      .delete(`${API_WP}WfhProfile/remove/${id}`)
      .then(() => {
        dispatch({
          type: DELETE_WFH_PROFILE_SUCCESS,
          payload: id
        });
        console.log('aaaaaaaaaaaaaaa');
      })
      .catch(error => {
        console.log('ttttttttttttttttttttttttttttt', error);
        dispatch({
          type: DELETE_WFH_PROFILE_FAILURE,
          payload: error.response.data.message
        });
      });
  };
};

export const getPlanningByWeeks = data => {
  return dispatch => {
    dispatch({
      type: FETCH_PLANNING_LOADING
    });
    api
      .post(`${API_WP}WfhProfile/planning/getPlanningByWeeks`, data)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_PLANNING_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_PLANNING_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getPlanningByWeek = data => {
  return dispatch => {
    dispatch({
      type: FETCH_PLANNING_LOADING
    });
    api
      .post(`${API_WP}WfhProfile/planning/getPlanningByWeek`, data)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_PLANNING_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_PLANNING_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const createOrUpdatePlanning = data => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      api
        .put(`${API_WP}WfhProfile/planning/update`, data)
        .then(response => {
          const { data } = response.data;
          dispatch({
            type: UPDATE_PLANNING_SUCCESS,
            payload: data
          });
          resolve({ status: 200, data: data });
        })
        .catch(error => {
          const errorMsg = error.message;
          dispatch({
            type: UPDATE_PLANNING_FAILURE,
            payload: errorMsg
          });
          reject(errorMsg);
        });
    });
  };
};
